import { log } from "./logging";

let selectedCameraDevice: MediaDeviceInfo | null = null;
let selectedCameraStream: MediaStream | null = null;

export const SetCameraStreamInfo = async () => {
    if (selectedCameraDevice != null)
        selectedCameraDevice = null;

    if (selectedCameraStream != null) {
        selectedCameraStream.getTracks().forEach(track => {
            try {
                track.stop();
            } catch (e) { }
        });
        selectedCameraStream = null;
    }

    const availableDevices: MediaDeviceInfo[] = await navigator.mediaDevices.enumerateDevices();
    const SWFHMultiCamDeviceInfo: MediaDeviceInfo | undefined = availableDevices.find((device: MediaDeviceInfo) => device.kind == "videoinput" && device.label === "SWFH Multi Camera");

    if (SWFHMultiCamDeviceInfo != null) {
        try {
            const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId: { exact: SWFHMultiCamDeviceInfo.deviceId } } });
            log.info(`SWFH Multi Camera detected`);
            selectedCameraStream = stream;
            selectedCameraDevice = SWFHMultiCamDeviceInfo;
        }
        catch (error: any) {
            log.error(`Error in getCameraStream - SWFH Multi Camera (${SWFHMultiCamDeviceInfo.deviceId}) is not working, switching to regular camera`, error);

            for (const device of availableDevices) {
                if (device.kind === "videoinput" && device.label !== "SWFH Multi Camera" && device.label !== "SWFH Multi Camera Selfie") {
                    try {
                        const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId: { exact: device.deviceId } } });
                        selectedCameraStream = stream;
                        selectedCameraDevice = device;
                        break;
                    }
                    catch (error: any) {
                        log.error(`Error in getCameraStream - An error occurred while trying to capture camera ${device.deviceId}`, error);
                    }
                }
            }
        }
    }
    else for (const device of availableDevices) {
        if (device.kind == "videoinput") {
            try {
                const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId: { exact: device.deviceId } } });
                selectedCameraStream = stream;
                selectedCameraDevice = device;
                break;
            }
            catch (error: any) {
                log.error(`Error in getCameraStream - An error occurred while trying to capture camera ${device.deviceId}`, error);
            }
        }
    }
}

export const CloseCameraStream = (): void => {
    if (selectedCameraStream != null) {
        selectedCameraStream.getTracks().forEach(track => {
            try {
                track.stop();
            } catch (e) { }
        });
        selectedCameraStream = null;
    }
}

export const TriggerStreamForPermission = async () => {
    try {
        const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ audio: false, video: true });

        stream.getTracks().forEach(track => {
            try {
                track.stop();
            } catch (e) { }
        });
    }
    catch (error) {
        log.error(`Error in TriggerStreamForPermission - An error occurred while trying to capture camera`, error);
    }
}

export const GetCameraStreamInfo = () => selectedCameraStream;
export const GetCameraDeviceInfo = () => selectedCameraDevice;